import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Linkedin, Twitter, Facebook } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-b from-gray-900 to-gray-950 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <div className="w-10 h-10 bg-gradient-to-br from-blue-600 to-blue-800 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-xl">ZT</span>
              </div>
              <div className="flex flex-col">
                <span className="font-bold text-lg text-white leading-tight">Zen Tech</span>
                <span className="text-xs text-blue-400 leading-tight">Services</span>
              </div>
            </div>
            <p className="text-sm text-gray-400">
              Transforming businesses through innovative technology solutions in trading automation, cloud infrastructure, and digital transformation.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              {["Home", "Services", "Projects", "Case Studies", "Technologies", "About"].map((item) => (
                <li key={item}>
                  <Link
                    to={item === "Home" ? "/" : `/${item.toLowerCase().replace(" ", "-")}`}
                    className="text-sm hover:text-blue-400 transition-colors duration-200"
                  >
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold mb-4">Services</h3>
            <ul className="space-y-2">
              <li className="text-sm hover:text-blue-400 transition-colors duration-200 cursor-pointer">
                Algo Trading Automation
              </li>
              <li className="text-sm hover:text-blue-400 transition-colors duration-200 cursor-pointer">
                AWS & Azure Cloud Solutions
              </li>
              <li className="text-sm hover:text-blue-400 transition-colors duration-200 cursor-pointer">
                Contact Center Automation
              </li>
              <li className="text-sm hover:text-blue-400 transition-colors duration-200 cursor-pointer">
                React & Java Development
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">Get In Touch</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3 text-sm">
                <Mail size={18} className="text-blue-400 mt-0.5 flex-shrink-0" />
                <a href="mailto:info@zentechservices.in" className="hover:text-blue-400 transition-colors duration-200">
                  info@zentechservices.in
                </a>
              </li>
              <li className="flex items-start space-x-3 text-sm">
                <Phone size={18} className="text-blue-400 mt-0.5 flex-shrink-0" />
                <a href="tel:+919490191839" className="hover:text-blue-400 transition-colors duration-200">
                  +91 9490191839
                </a>
              </li>
              <li className="flex items-start space-x-3 text-sm">
                <MapPin size={18} className="text-blue-400 mt-0.5 flex-shrink-0" />
                <span>Gurugram, India</span>
              </li>
            </ul>
            <div className="flex space-x-4 mt-4">
              <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors duration-200">
                <Linkedin size={20} />
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors duration-200">
                <Twitter size={20} />
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors duration-200">
                <Facebook size={20} />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-400">
              © {currentYear} Zen Tech Services. All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm">
              <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors duration-200">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors duration-200">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
